<div *ngIf="global_texts && loginForm" class="all-content login">
  <div class="content">
    <div class="inner-content w-100">
      <div class="left-module bloc-image"></div>
      <div class="right-module py-0 px-2 py-lg-5 px-lg-5 justify-content-center align-items-center">

        <app-logos-unlogged></app-logos-unlogged>

        <div class="my-4 text-center">
          <h5 class="fw-semi-bold" [innerHtml]="global_texts.login_page.intro"></h5>
        </div>

        <div class="py-4 d-flex flex-column justify-content-center align-items-center">

          <!-- Bubble Title Login -->
          <div class="bubble-step mb-5 bloc-login-form">
            <div class="title">
              <h1 [innerHtml]="global_texts.login_page.title"></h1>
            </div>

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
              <h6 class="mb-3 fw-semi-bold" [innerHtml]="global_texts.login_page.text_info"></h6>

              <!-- Email -->
              <div class="mb-4">
                <input class="form-control with-picto user" [attr.placeholder]="global_texts.login_page.login"
                       type="text" formControlName="login" autocomplete="new-login">
                <div *ngIf="submitted && loginForm.controls['login'].errors" class="small fw-bold color-red mt-2">
                  <div
                    *ngIf="loginForm.controls['login'].errors?.['required']"
                    [innerHtml]="global_texts.error_messages.validator_required">
                  </div>
                  <div
                    *ngIf="loginForm.controls['login'].errors?.['pattern']"
                    [innerHtml]="global_texts.error_messages.validator_email">
                  </div>
                </div>
              </div>

              <!-- Password -->
              <div class="mb-4">
                <input class="form-control with-picto mdp" [attr.placeholder]="global_texts.login_page.password"
                       type="password" formControlName="password" autocomplete="new-password">
                <div *ngIf="submitted && loginForm.controls['password'].errors" class="small fw-bold color-red mt-2">
                  <div
                    *ngIf="loginForm.controls['password'].errors?.['required']"
                    [innerHtml]="global_texts.error_messages.validator_required">
                  </div>
                </div>
              </div>

              <!-- Login -->
              <div class="text-center mb-4">
                <button type="submit" class="btn btn-solid-green" [innerHtml]="global_texts.login"></button>
              </div>

              <!-- Forgot password -->
              <div class="mb-4">
                <p>
                  <span class="fw-bold" [innerHtml]="global_texts.login_page.forgot_password"></span>
                  <br class="d-block d-lg-none"/>
                  <a role="button" class="link-green d-block d-lg-inline mt-2 mt-lg-0" [routerLink]="'/' +
                  RouterLinks.PasswordReminder">
                    <span class="fw-black" [innerHtml]="' ' + global_texts.click_here"></span>
                  </a>
                </p>
              </div>

              <hr/>

              <!-- Have no account -->
              <div class="mt-4">
                <p>
                  <span class="fw-bold" [innerHtml]="global_texts.login_page.have_no_account"></span>
                </p>
                <div class="text-center mb-4">
                  <button type="button" class="btn btn-solid-red" [routerLink]="'/' + RouterLinks.CreateAccount"
                          [innerHtml]="global_texts.login_page.create_account"></button>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
